<div class="breadcrumb">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.lt-lg="90%">
            <ul>
                <li [routerLink]="['/']" routerLinkActive="router-link-active">Inicio</li>
                <li *ngIf="category" [routerLink]="['/buscar/categoria/'+ category.id + '/' + category.title]" routerLinkActive="router-link-active">{{ category.title }}</li>
                <li *ngIf="queryText != '' && queryText !== undefined" routerLinkActive="router-link-active" class="active">{{ queryText}}</li>
            </ul>
        </div>
    </div>
</div>